import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=45e4578e&"
import script from "./TreeItem.vue?vue&type=script&lang=js&"
export * from "./TreeItem.vue?vue&type=script&lang=js&"
import style0 from "./TreeItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports